import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import AppPresentation from './AppPresentation';
// import AppLPay from './AppLPay';
// import AppRentcar from './AppRentcar';
// import AppKejati from './AppKejati';
// import AppPPSUERP from './AppPPSUERP';
// import AppPPSUHR from './AppPPSUHR';
// import AppMaintenance from './AppMaintenance';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
    // <AppRentcar/>
    // <AppKejati/>
    // <AppPPSUERP/>
    // <AppPPSUHR/>
    // <AppPresentation/>
    // <AppLPay/>
    // <AppMaintenance/>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
